module.exports = __webpack_public_path__ + "static/media/img_12.bf0403d6.png";